import { useEffect, useState } from "react";
import { cargarInventario } from "../../../services/admin/inventario";

function InventoryLoadModal({ isOpen, onClose, product, onSuccess }) {
  const [cantidad, setCantidad] = useState(1);
  const [observacion, setObservacion] = useState("");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);

  const getNiceErrorMessage = (error, fallback = "Error adding inventory.") => {
    const msg =
      error?.response?.data?.message ||
      error?.message ||
      fallback;

    const clean = String(msg).replace(/\s+/g, " ").trim();
    return clean.length > 240 ? clean.slice(0, 240) + "…" : clean;
  };

  useEffect(() => {
    if (!isOpen || !product) return;

    setCantidad(1);
    setObservacion("");
    setLoading(false);
    setAlert(null);
  }, [isOpen, product?.producto_id]);

  useEffect(() => {
    if (!isOpen) return;

    const handler = (e) => {
      if (e.key === "Escape") onClose?.();
    };

    window.addEventListener("keydown", handler);
    return () => window.removeEventListener("keydown", handler);
  }, [isOpen, onClose]);

  if (!isOpen || !product) return null;

  const closeIfBackdrop = (e) => {
    if (e.target === e.currentTarget && !loading) onClose?.();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setAlert(null);

    const qty = Number(cantidad);

    if (!Number.isFinite(qty) || qty <= 0) {
      setAlert({ type: "error", message: "Quantity must be greater than zero." });
      return;
    }

    try {
      setLoading(true);

      await cargarInventario({
        producto_id: product.producto_id,
        cantidad: qty,
        observacion: observacion?.trim() || null,
      });

      onSuccess?.();
      onClose?.();
    } catch (err) {
      console.error("Inventory load failed:", err);
      setAlert({ type: "error", message: getNiceErrorMessage(err) });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="adc-modal-backdrop" onMouseDown={closeIfBackdrop}>
      <div className="adc-modal" onMouseDown={(e) => e.stopPropagation()}>
        <h3 className="adc-modal-title">Add Inventory</h3>

        <p className="adc-modal-subtitle">
          {product.nombre} {product.no_parte ? `• ${product.no_parte}` : ""}
        </p>

        {alert && (
          <div className={`adc-alert adc-alert--${alert.type}`}>
            <span>{alert.message}</span>
            <button
              type="button"
              className="adc-alert-x"
              onClick={() => setAlert(null)}
              disabled={loading}
              aria-label="Close alert"
            >
              ✕
            </button>
          </div>
        )}

        <form onSubmit={handleSubmit} className="adc-modal-form">
          <label>
            Quantity
            <input
              type="number"
              min="1"
              step="1"
              value={cantidad}
              onChange={(e) => setCantidad(e.target.value)}
              required
              disabled={loading}
              placeholder="e.g. 10"
            />
          </label>

          <label>
            Note (optional)
            <textarea
              value={observacion}
              onChange={(e) => setObservacion(e.target.value)}
              placeholder="Optional note about this inventory load"
              disabled={loading}
            />
          </label>

          <div className="adc-modal-actions">
            <button
              type="button"
              className="btn-secondary"
              onClick={onClose}
              disabled={loading}
            >
              Cancel
            </button>

            <button type="submit" className="btn-primary" disabled={loading}>
              {loading ? "Saving..." : "Add Inventory"}
            </button>
          </div>
        </form>

        <style>{`
          .adc-alert{
            margin: 12px 0 0;
            padding: 10px 12px;
            border-radius: 10px;
            border: 1px solid;
            display:flex;
            align-items:center;
            justify-content:space-between;
            gap: 12px;
            font-weight: 700;
            font-size: 13px;
          }
          .adc-alert--error{
            background:#FEF2F2;
            border-color:#FECACA;
            color:#7F1D1D;
          }
          .adc-alert--info{
            background:#EFF6FF;
            border-color:#BFDBFE;
            color:#1E3A8A;
          }
          .adc-alert-x{
            border:none;
            background:transparent;
            cursor:pointer;
            font-size: 16px;
            opacity:.7;
          }
          .adc-alert-x:hover{ opacity: 1; }
        `}</style>
      </div>
    </div>
  );
}

export default InventoryLoadModal;
